import { render, staticRenderFns } from "./AsfTextArea.vue?vue&type=template&id=2f7b6a72"
import script from "./AsfTextArea.vue?vue&type=script&lang=js"
export * from "./AsfTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports